import { DetalleLineaComponent } from './../../operaciones/linea-adquirente/detalle-linea/detalle-linea.component';
import { NuevaLineaComponent } from './../../operaciones/linea-adquirente/nueva-linea/nueva-linea.component';
import { ListaLineasComponent } from './../../operaciones/linea-adquirente/lista-lineas/lista-lineas.component';
import { LineaAdquirenteComponent } from './../../operaciones/linea-adquirente/linea-adquirente.component';
import { DashboardConcentracionFondoComponent } from './../../fondo/concentracion-fondo/dashboard-concentracion-fondo/dashboard-concentracion-fondo.component';
import { DetalleEvaluacionOperacionComponent } from './../../operaciones/evaluacion-operacion/detalle-evaluacion-operacion/detalle-evaluacion-operacion.component';
import { FinanciamientoComponent } from './../../fondo/financiamiento/financiamiento.component';
import { ListadoFinanciamientoComponent } from './../../fondo/financiamiento/listado/listado-financiamiento.component';
import { TraspasoInversionComponent } from './../../fondo/financiamiento/traspaso/traspaso-inversion.component';
import { RetiroInversionComponent } from './../../fondo/concentracion-fondo/fondos/retiro/retiro-inversion.component';
import { DepositoInversionComponent } from './../../fondo/concentracion-fondo/fondos/deposito/deposito-inversion.component';

import { LetrasCambioComponent } from './../../negociables/letra/letras-cambio/letras-cambio.component';
import { LetraComponent } from './../../negociables/letra/letra.component';
import { NegociacionesComponent } from 'app/cobranza/negociaciones/negociaciones.component';
import { ListadoReprogramacionComponent } from 'app/cobranza/negociaciones/listado-reprogramacion/listado-reprogramacion.component';
import { ListadoCobranzaJudicialComponent } from 'app/cobranza/negociaciones/listado-cobranza-judicial/listado-cobranza-judicial.component';

import { Routes } from '@angular/router';
import { DashboardComponent } from '../../dashboard/dashboard.component';
import { EmpresasComponent } from '../../empresas/empresas.component';
import { NegociablesComponent } from '../../negociables/negociables.component';

import { CobranzaComponent } from '../../cobranza/cobranza.component';
import { NuevoCobranzaComponent } from '../../cobranza/cobranzas/nuevo-cobranza/nuevo-cobranza.component';
import { PagosComponent} from '../../cobranza/pagos/pagos.component';
import { CobranzasComponent } from '../../cobranza/cobranzas/cobranzas.component';
import { LiquidacionComponent } from '../../liquidacion/liquidacion.component';
import { UpgradeComponent } from '../../upgrade/upgrade.component';
import { FacturaElectronicaComponent } from '../../negociables/factura/factura-electronica/factura-electronica.component';
import { ListadoDocNegComponent } from '../../negociables/listado-doc-neg/listado-doc-neg.component';
import { FacturaFisicaComponent } from '../../negociables/factura/factura-fisica/factura-fisica.component';
import { ReciboHonorarioComponent } from '../../negociables/recibo/recibo-honorario/recibo-honorario.component';
import { PersonaComponent } from '../../persona/persona.component';
import { ContactosComponent } from '../../empresas/contactos/contactos.component';
import { ProveedoresComponent } from '../../empresas/proveedores/proveedores.component';
import { AdquirentesComponent } from '../../empresas/adquirentes/adquirentes.component';
import { RegProveedorComponent } from '../../empresas/proveedores/reg-proveedor/reg-proveedor.component';
import { RegInversorComponent } from '../../empresas/inversores/reg-inversor/reg-inversor.component';
import { RegAdquirenteComponent } from '../../empresas/adquirentes/reg-adquirente/reg-adquirente.component';
import { ListProveedorComponent } from '../../empresas/proveedores/list-proveedor/list-proveedor.component';
import { ListAdquirenteComponent } from '../../empresas/adquirentes/list-adquirente/list-adquirente.component';
import { RefBancariasComponent } from '../../empresas/ref-bancarias/ref-bancarias.component';
import { ReciboComponent } from '../../negociables/recibo/recibo.component';
import { FacturaComponent } from '../../negociables/factura/factura.component';
import { OperacionesComponent } from '../../operaciones/operaciones.component';
import { ListadoProformasComponent } from '../../operaciones/proformas/listado-proformas/listado-proformas.component';
import { NuevoProformaComponent } from '../../operaciones/proformas/nuevo-proforma/nuevo-proforma.component';
import { ListadoDocumentosAsociadosComponent } from '../../operaciones/proformas/listado-documentos-asociados/listado-documentos-asociados.component';
import { ListadoPagoComponent } from '../../cobranza/pagos/listado-pago/listado-pago.component';
import { ListadoCobranzaComponent } from '../../cobranza/cobranzas/listado-cobranza/listado-cobranza.component';
import { ContratosMarcoComponent} from '../../empresas/contratos-marco/contratos-marco.component'
import { DetallePagoComponent } from '../../cobranza/pagos/detalle-pago/detalle-pago.component';
import { AdquirentePagoComponent } from '../../cobranza/pagos/adquirente-pago/adquirente-pago.component';
import {AdquirenteCuotaComponent} from '../../cobranza/pagos/adquirente-cuota/adquirente-cuota.component';
import { ReportesComponent } from '../../reportes/reportes.component';
import { RepComercialComponent } from '../../reportes/rep-comercial/rep-comercial.component';
import { ListadoRepComercialComponent } from '../../reportes/rep-comercial/listado-rep-comercial/listado-rep-comercial.component';
import { ReporteFacturaNegociadaComponent } from '../../reportes/rep-comercial/factura-negociada/factura-negociada.component';
import { ReporteCalculoComisionComponent } from '../../reportes/rep-comercial/calculo-comision/calculo-comision.component';
import { ReporteClienteObligadoComponent } from '../../reportes/rep-comercial/cliente-obligado/cliente-obligado.component';
import { ReporteNumeroOperacionesComponent } from '../../reportes/rep-comercial/numero-operaciones/numero-operaciones.component';

import { CavaliComponent } from '../../cavali/cavali.component';
import { TesoreriaComponent } from '../../tesoreria/tesoreria.component';
import { DesembolsoComponent } from '../../tesoreria/desembolso/desembolso.component';
import { ListadoDesembolsoComponent } from '../../tesoreria/desembolso/listado-desembolso/listado-desembolso.component';
import { NuevoDesembolsoComponent } from '../../tesoreria/desembolso/nuevo-desembolso/nuevo-desembolso.component';
import { ConfirmarDesembolsoComponent } from '../../tesoreria/desembolso/confirmar-desembolso/confirmar-desembolso.component';
import { DeudasComponent } from '../../cobranza/deudas/deudas.component';
import { ListadoDeudasComponent } from '../../cobranza/deudas/listado-deudas/listado-deudas.component';
import { ListadoAreaComponent } from 'app/meta/area/listado-area/listado-area.component';
import { NuevoAreaComponent } from 'app/meta/area/nuevo-area/nuevo-area.component';
import { AuthGuard } from '../../guards/auth.guard';
import { ContabilidadComponent } from '../../contabilidad/contabilidad.component';
import { LiquidacionesComponent } from 'app/liquidacion/liquidaciones/liquidaciones.component';
import { ListadoLiquidacionesComponent } from 'app/liquidacion/liquidaciones/listado-liquidaciones/listado-liquidaciones.component';
import { PlanillaLiquidacionesComponent } from 'app/liquidacion/liquidaciones/planilla-liquidaciones/planilla-liquidaciones.component';
import { NuevaLiquidacionComponent } from 'app/liquidacion/liquidaciones/nueva-liquidacion/nueva-liquidacion.component';
import { NuevoPlanillaLiquidacionComponent } from '../../tesoreria/desembolso/nuevo-planillaLiquidacion/nuevo-planillaLiquidacion.component';
import { ListadoCavaliComponent } from '../../cavali/listado-cavali/listado-cavali.component';
import { ProcesoCavaliComponent } from '../../cavali/proceso-cavali/proceso-cavali.component';
import { RegistrarCavaliComponent } from '../../cavali/registrar-cavali/registrar-cavali.component';

import { InversionComponent } from '../../inversion/inversion.component';
import { InversionistasComponent } from '../../inversion/inversionistas/inversionistas.component';
import { ListadoInversionistasComponent } from '../../inversion/inversionistas/listado-inversionistas/listado-inversionistas.component';
import { NuevoInversionComponent } from '../../inversion/inversionistas/nuevo-inversion/nuevo-inversion.component';
import { LibroReclamacionesComponent } from 'app/libro-reclamaciones/libro-reclamaciones.component';
import { QuejasReclamosComponent } from 'app/libro-reclamaciones/quejas-reclamos/quejas-reclamos.component';
import { ListadoQuejasReclamosComponent } from 'app/libro-reclamaciones/quejas-reclamos/listado-quejas-reclamos/listado-quejas-reclamos.component';
import { NuevoQuejasReclamosComponent } from './../../libro-reclamaciones/quejas-reclamos/nuevo-quejas-reclamos/nuevo-quejas-reclamos.component';
import { NuevoCpeComponent } from './../../facturacion/nuevo-cpe/nuevo-cpe.component';
import { CpeNotaDebitoComponent } from './../../facturacion/nota-debito/cpe-nota-debito/cpe-nota-debito.component';
import { NotaDebitoComponent } from './../../facturacion/nota-debito/nota-debito.component';
import { CpeNotaCreditoComponent } from './../../facturacion/nota-credito/cpe-nota-credito/cpe-nota-credito.component';
import { NotaCreditoComponent } from './../../facturacion/nota-credito/nota-credito.component';
import { CpeFacturaComponent } from './../../facturacion/facturas/cpe-factura/cpe-factura.component';
import { ListadoCpeComponent } from './../../facturacion/listado-cpe/listado-cpe.component';
import { FacturasComponent } from './../../facturacion/facturas/facturas.component';
import { FacturacionComponent } from './../../facturacion/facturacion.component';
import { VerificacionPlanillaDesembolsoComponent } from 'app/tesoreria/desembolso/verificacion-planilla-desembolso/verificacion-planilla-desembolso.component';
import { RepFinanzasComponent } from 'app/reportes/rep-finanzas/rep-finanzas.component';
import { FondoInversionComponent } from 'app/reportes/rep-finanzas/fondo-inversion/fondo-inversion.component';
import { AccialComponent } from 'app/reportes/rep-finanzas/accial/accial.component';
import { RiesgoComponent } from '../../riesgo/riesgo.component';
import { FondoComponent } from '../../fondo/fondo.component';
import { ConcentracionFondoComponent } from './../../fondo/concentracion-fondo/concentracion-fondo.component';
import { EmpresaRiesgoComponent } from '../../riesgo/empresa-riesgo/empresa-riesgo.component';
import { ListadoEmpresaRiesgoComponent } from '../../riesgo/empresa-riesgo/listado-empresa-riesgo/listado-empresa-riesgo.component';
import { NuevaEmpresaRiesgoComponent } from '../../riesgo/empresa-riesgo/nueva-empresa-riesgo/nueva-empresa-riesgo.component';
import { ListadoExcepcionesComponent } from '../../riesgo/empresa-riesgo/listado-excepciones/listado-excepciones.component';
import { InversoresComponent } from '../../empresas/inversores/inversores.component';
import { ListInversoresComponent } from '../../empresas/inversores/list-inversores/list-inversores.component';
import { ConfInversoresComponent } from '../../empresas/inversores/conf-inversores/conf-inversores.component';
import { ContratoMarcoComponent } from '../../contrato-marco/contrato-marco.component';
import { ListadoContratoMarcoComponent } from '../../contrato-marco/listado-contrato-marco/listado-contrato-marco.component';
import { PagareComponent } from '../../contrato-marco/pagare/pagare.component';
import { SimuladorComponent } from '../../operaciones/simulador/simulador.component';
import { ListadoSimuladorComponent } from '../../operaciones/simulador/listado-simulador/listado-simulador.component';
import { SimuladorNuevoComponent } from '../../operaciones/simulador/simulador-nuevo/simulador-nuevo.component';
import { OperacionComponent } from '../../operaciones/operacion/operacion.component';
import { ConfirmingComponent } from '../../operaciones/confirming/confirming.component';
import { ListadoOperacionComponent } from '../../operaciones/operacion/listado-operacion/listado-operacion.component';
import { ListadoConfirmingComponent } from '../../operaciones/confirming/listado-confirming/listado-confirming.component';
import { OperacionDetalleComponent } from '../../operaciones/operacion/operacion-detalle/operacion-detalle.component';
import { ConfirmingDetalleComponent } from '../../operaciones/confirming/confirming-detalle/confirming-detalle.component';
import { NuevaOperacionComponent } from '../../operaciones/operacion/nueva-operacion/nueva-operacion.component';
import { NuevaConfirmingComponent } from '../../operaciones/confirming/nuevo-confirming/nuevo-confirming.component';
import { NotificarSolicitudDesembolsoComponent } from '../../operaciones/solicitud-desembolso/notificar-solicitud-desembolso/notificar-solicitud-desembolso.component';
import { SolicitudDesembolsoComponent } from '../../operaciones/solicitud-desembolso/solicitud-desembolso.component';
import { ListadoSolicitudDesComponent } from '../../operaciones/solicitud-desembolso/listado-solicitud-des/listado-solicitud-des.component';
import { SolicitudDesDetalleComponent } from '../../operaciones/solicitud-desembolso/solicitud-des-detalle/solicitud-des-detalle.component';
import { NuevoSolicitudDesComponent } from '../../operaciones/solicitud-desembolso/nuevo-solicitud-des/nuevo-solicitud-des.component';
import { ProformasComponent } from '../../operaciones/proformas/proformas.component';

import { DocumentosSubastaComponent } from '../../riesgo/documentos-subasta/documentos-subasta.component';
import { ListadoDnSubastaComponent } from '../../riesgo/documentos-subasta/listado-dnsubasta/listado-dnsubasta.component';
import { ListadoDocumentosXSubastarComponent } from '../../riesgo/documentos-subasta/listado-documentos-xsubastar/listado-documentos-xsubastar.component';
import { NuevoDnSubastaComponent } from '../../riesgo/documentos-subasta/nuevo-dnsubasta/nuevo-dnsubasta.component';
import { EmpresaSegComponent } from '../../configuracion/empresa-seg/empresa-seg.component';
import { ListadoComponent } from '../../configuracion/empresa-seg/listado/listado.component';
import { NuevoEmpresaComponent } from '../../configuracion/empresa-seg/nuevo-empresa/nuevo-empresa.component';
import { ParametroComponent } from '../../configuracion/empresa-seg/parametro/parametro.component';
import { SistemaComponent } from '../../configuracion/sistema/sistema.component';
import { NuevoSistemaComponent } from '../../configuracion/sistema/nuevo-sistema/nuevo-sistema.component';
import { ListadoSistemaComponent } from '../../configuracion/sistema/listado-sistema/listado-sistema.component';
import { RolComponent } from '../../configuracion/rol/rol.component';
import { NuevoRolComponent } from '../../configuracion/rol/nuevo-rol/nuevo-rol.component';
import { ListadoRolComponent } from '../../configuracion/rol/listado-rol/listado-rol.component';
import { AccesoComponent } from '../../configuracion/acceso/acceso.component';
import { ListadoAccesoComponent } from 'app/configuracion/acceso/listado-acceso/listado-acceso.component';
import { NuevoAccesoComponent } from '../../configuracion/acceso/nuevo-acceso/nuevo-acceso.component';
import { PermisoComponent } from '../../configuracion/permiso/permiso.component';
import { ListadoPermisoComponent } from 'app/configuracion/permiso/listado-permiso/listado-permiso.component';
import { NuevoPermisoComponent } from '../../configuracion/permiso/nuevo-permiso/nuevo-permiso.component';
import { ComponentesComponent } from '../../configuracion/componentes/componentes.component';
import { ListadoComponenteComponent } from '../../configuracion/componentes/listado-componente/listado-componente.component';
import { NuevoComponenteComponent } from '../../configuracion/componentes/nuevo-componente/nuevo-componente.component';
import { PermisoComponenteComponent } from '../../configuracion/componentes/permiso-componente/permiso-componente.component';
import { GuiasComponent } from '../../configuracion/guias/guias.component';
import { ListadoGuiaComponent } from '../../configuracion/guias/listado-guia/listado-guia.component';
import { UsuarioComponent } from '../../configuracion/usuarios/usuario.component';
import { NuevoUsuarioComponent } from '../../configuracion/usuarios/nuevo-usuario/nuevo-usuario.component';
import { ListaUsuarioComponent } from '../../configuracion/usuarios/lista/lista-usuario.component';
import { ProspectosComponent } from '../../operaciones/prospectos/prospectos.component';
import { ListadoOperacionesProspectosComponent } from '../../operaciones/prospectos/listado-operaciones-prospectos/listado-operaciones-prospectos.component';
import { ProspectoRespuestaComponent } from 'app/riesgo/prospecto-respuesta/prospecto-respuesta.component';
import { NuevaRespuestaProspectoComponent } from 'app/riesgo/prospecto-respuesta/nueva-respuesta-prospecto/nueva-respuesta-prospecto.component';
import { ListadoProspectosComponent } from 'app/riesgo/prospecto-respuesta/listado-prospectos/listado-prospectos.component';
import { DashboardTablerosComponent } from 'app/dashboardTableros/dashboardTableros.component';
import { RepContabilidadComponent } from 'app/reportes/rep-contabilidad/rep-contabilidad.component';
import { ListaComprobanteElectronicoComponent } from 'app/reportes/rep-contabilidad/comprobante-electronico/lista-comprobante-electronico/lista-comprobante-electronico.component';
import { ListaComprobanteIfComponent } from 'app/reportes/rep-contabilidad/comprobante-if/lista-comprobante-if/lista-comprobante-if.component';
import { ListadoRepConciliacionesComponent } from 'app/reportes/rep-contabilidad/listado-rep-conciliaciones/listado-rep-conciliaciones.component';
import { ListadoPagoAdqComponent } from 'app/reportes/rep-finanzas/listado-pago-adq/listado-pago-adq.component';
import { PagaresComponent } from 'app/empresas/pagares/pagares.component';
import { ListadoPagareComponent } from 'app/empresas/pagares/listado-pagare/listado-pagare.component';
import { ListaTipoCambioComponent } from 'app/contabilidad/lista/lista-tipo-cambio.component';
import { NuevoTipoCambioComponent } from 'app/contabilidad/nuevo-tipo-cambio/nuevo-tipo-cambio.component';
import { EvaluacionOperacionComponent } from 'app/operaciones/evaluacion-operacion/evaluacion-operacion.component';
import { ListaEvaluacionOperacionComponent } from 'app/operaciones/evaluacion-operacion/lista-evaluacion-operacion/lista-evaluacion-operacion.component';
import { NuevoEvaluacionOperacionComponent } from 'app/operaciones/evaluacion-operacion/nuevo-evaluacion-operacion/nuevo-evaluacion-operacion.component';
import { ListaDocumentosComponent } from 'app/operaciones/evaluacion-operacion/lista-documentos/lista-documentos.component';
import { RepConciliacionComponent } from 'app/reportes/rep-finanzas/rep-conciliacion/rep-conciliacion.component';
import { RepMensualComponent } from 'app/reportes/rep-finanzas/rep-mensual/rep-mensual.component';
import { CarteraRiesgoComponent } from 'app/riesgo/cartera-riesgo/cartera-riesgo.component';
import { ListadoSectorComponent } from 'app/riesgo/configuracion-riesgo/listado-sector/listado-sector.component';
import { NuevoSectorComponent } from 'app/riesgo/configuracion-riesgo/nuevo-sector/nuevo-sector.component';
import { ConfiguracionRiesgoComponent } from 'app/riesgo/configuracion-riesgo/configuracion-riesgo.component';
import { SectorEmpresaComponent } from 'app/riesgo/configuracion-riesgo/sector-empresa/sector-empresa.component';
import { FondosComponent } from 'app/fondo/concentracion-fondo/fondos/fondos.component';
import { NuevoFondoComponent } from 'app/fondo/concentracion-fondo/fondos/nuevo-fondo/nuevo-fondo.component';
import { ListadoFondosComponent } from 'app/fondo/concentracion-fondo/fondos/listado-fondos/listado-fondos.component';
import { GarantiasComponent } from 'app/fondo/concentracion-fondo/garantias/garantias.component';
import { NuevaGarantiaComponent } from 'app/fondo/concentracion-fondo/garantias/nueva-garantia/nueva-garantia.component';
import { ListadoGarantiasComponent } from 'app/fondo/concentracion-fondo/garantias/listado-garantias/listado-garantias.component';
import { ListaNegraComponent } from 'app/riesgo/empresa-riesgo/lista-negra/lista-negra.component';
import { RepMarketingComponent } from 'app/reportes/rep-marketing/rep-marketing.component';
import { ListadoRepMarketingComponent } from 'app/reportes/rep-marketing/listado-rep-marketing/listado-rep-marketing.component';
import { ResumenLiquidacionComponent } from 'app/liquidacion/resumen-liquidacion/resumen-liquidacion.component';
import { ListadoResumenComponent } from 'app/liquidacion/resumen-liquidacion/listado-resumen/listado-resumen.component';
import { NuevoResumenComponent } from 'app/liquidacion/resumen-liquidacion/nuevo-resumen/nuevo-resumen.component';
import { RepConcarComponent } from 'app/reportes/rep-finanzas/rep-concar/rep-concar.component';
import { CargaMasivaComponent } from 'app/negociables/factura/carga-masiva/carga-masiva.component';
import { ListarFacturasGeneradasComponent } from 'app/reportes/rep-contabilidad/listar-facturas-generadas/listar-facturas-generadas.component';
import { OperacionesDetalladasTiempoComponent } from 'app/reportes/rep-contabilidad/operaciones-detalladas-tiempo/operaciones-detalladas-tiempo.component';
import { OperacionesGeneralComponent } from 'app/reportes/rep-contabilidad/operaciones-general/operaciones-general.component';
import { FacturasNegociadasFondoComponent } from 'app/reportes/rep-contabilidad/facturas-negociadas-fondo/facturas-negociadas-fondo.component';
import { FacturasNegSectorFondoComponent } from 'app/reportes/rep-contabilidad/facturas-neg-sector-fondo/facturas-neg-sector-fondo.component';
import { FacturasNegProcesoSectorComponent } from 'app/reportes/rep-contabilidad/facturas-neg-proceso-sector/facturas-neg-proceso-sector.component';
import { ListadoOperacionesEstadoComponent } from 'app/reportes/rep-finanzas/listado-operaciones-estado/listado-operaciones-estado.component';
import { StockCarteraComponent } from 'app/reportes/rep-finanzas/stock-cartera/stock-cartera.component';
import { CancelacionesOperacionesComponent } from 'app/reportes/rep-finanzas/cancelaciones-operaciones/cancelaciones-operaciones.component';
import { DevolucionRetencionesComponent } from 'app/reportes/rep-finanzas/devolucion-retenciones/devolucion-retenciones.component';
import { StockRetencionesComponent } from 'app/reportes/rep-finanzas/stock-retenciones/stock-retenciones.component';
import { DesembolsosOperacionesComponent } from 'app/reportes/rep-finanzas/desembolsos-operaciones/desembolsos-operaciones.component';
import { RepCobranzasComponent } from 'app/reportes/rep-cobranzas/rep-cobranzas.component';
import { ListadoFacturasVencidasComponent } from 'app/reportes/rep-cobranzas/listado-facturas-vencidas/listado-facturas-vencidas.component';
import { ListadoFacturasMeritoComponent } from 'app/reportes/rep-cobranzas/listado-facturas-merito/listado-facturas-merito.component';
import { ListadoFacturasJudicialComponent } from 'app/reportes/rep-cobranzas/listado-facturas-judicial/listado-facturas-judicial.component';
import { ListadoEmpresaClienteComponent } from 'app/reportes/rep-marketing/listado-empresa-cliente/listado-empresa-cliente.component';
import { ListadoEmpresaObligadoComponent } from 'app/reportes/rep-marketing/listado-empresa-obligado/listado-empresa-obligado.component';
import { ListadoEmpresaUltimaComponent } from 'app/reportes/rep-marketing/listado-empresa-ultima/listado-empresa-ultima.component';

export const AdminLayoutRoutes: Routes = [
    
    
    { path: 'dashboard', component: DashboardComponent ,canActivate: [AuthGuard]},
    { path: 'dashboardTableros', component: DashboardTablerosComponent ,canActivate: [AuthGuard]},
    {
        path: 'empresas',
        component: EmpresasComponent,
        children: [
            { path: 'proveedor', component: ProveedoresComponent ,
              canActivateChild:[AuthGuard] ,
              children:[
                { path: 'listado', component: ListProveedorComponent },
                { path: 'listado/:id', component: ListProveedorComponent },
                { path: 'nuevo', component: RegProveedorComponent },
                { path: 'editar/:id', component: RegProveedorComponent },
                { path: 'contactos/:id', component: ContactosComponent },
                { path: 'refBancarias/:id', component: RefBancariasComponent },
                { path: 'contratos/:id', component: ContratosMarcoComponent },
                { path: 'pagare', component: PagareComponent },
                { path: '**', redirectTo: 'listado', pathMatch: 'full', },

              ] },
            { path: 'adquirente' ,component: AdquirentesComponent,
                canActivateChild:[AuthGuard] ,
                children: [
                    { path: 'listado', component: ListAdquirenteComponent },
                    { path: 'listado/:id', component: ListAdquirenteComponent },
                    { path: 'nuevo', component: RegAdquirenteComponent },
                    { path: 'editar/:id', component: RegAdquirenteComponent },
                    { path: 'contactos/:id', component: ContactosComponent },
                    { path: 'refBancarias/:id', component: RefBancariasComponent },
                    { path: 'contratos/:id', component: ContratosMarcoComponent },
                    { path: 'pagare', component: PagareComponent },
                    { path: '**', redirectTo: 'listado', pathMatch: 'full', },
                ]},
            { path: 'contratoMarco' ,component: ContratoMarcoComponent,
            canActivateChild:[AuthGuard],
                children: [
                    { path: 'listado', component: ListadoContratoMarcoComponent},
                    { path: 'pagare', component: PagareComponent },
                    { path: '**', redirectTo: 'listado', pathMatch: 'full', },
                ]},
            { path: 'pagare' ,component: PagaresComponent,
            canActivateChild:[AuthGuard] ,
                children: [
                    { path: 'listado', component: ListadoPagareComponent},
                    { path: '**', redirectTo: 'listado', pathMatch: 'full', },
                ]},
            { path: 'inversor' ,component: InversoresComponent,
            canActivateChild:[AuthGuard],
            children: [
                { path: 'listado', component: ListInversoresComponent },
                { path: 'nuevo', component: RegInversorComponent },
                { path: 'editar/:id', component: RegInversorComponent }, 
                { path: 'contactos/:id', component: ContactosComponent },
                { path: 'contratos/:id', component: ContratosMarcoComponent },
                { path: 'verificacion', component: ConfInversoresComponent },
                { path: 'refBancarias/:id', component: RefBancariasComponent },
                { path: '**', redirectTo: 'listado', pathMatch: 'full', },
            ]},
        ]
    },

    {
        path: 'negociables',
        component: NegociablesComponent,
        children: [
            { path: 'factura', component: FacturaComponent,
             canActivateChild:[AuthGuard],
             children: [
                { path: 'listado', component: ListadoDocNegComponent },
                { path: 'FE', component: FacturaElectronicaComponent },
                { path: 'FF', component: FacturaFisicaComponent },
                { path: 'FE/:action/:id', component: FacturaElectronicaComponent },
                { path: 'FF/:action/:id', component: FacturaFisicaComponent },
                { path: 'carga-masiva', component: CargaMasivaComponent },
                { path: '**', redirectTo: 'listado', pathMatch: 'full', },
            ]},
            { path: 'recibo',  component: ReciboComponent,
            canActivateChild:[AuthGuard],
            children: [
                { path: 'listado', component: ListadoDocNegComponent },
                { path: 'RH', component: ReciboHonorarioComponent },
                { path: 'RH/:action/:id', component: ReciboHonorarioComponent },
                { path: 'RH/:action/:id', component: ReciboHonorarioComponent  },
                { path: '**', redirectTo: 'listado', pathMatch: 'full', },
            ]},
            { path: 'letra',  component: LetraComponent,
            canActivateChild:[AuthGuard],
            children: [
                { path: 'listado', component: ListadoDocNegComponent },
                { path: 'LC', component: LetrasCambioComponent },
                { path: 'LC/:action/:id', component: LetrasCambioComponent },
                { path: 'LC/:action/:id', component: LetrasCambioComponent  },
                { path: '**', redirectTo: 'listado', pathMatch: 'full', },
            ]},                          
        ]
    },
    { path: 'persona', component: PersonaComponent },
    {
        path: 'riesgo',
        component:RiesgoComponent,
        children: [
            {path: 'dnsubasta', component: DocumentosSubastaComponent,
                   canActivateChild:[AuthGuard],
                   children: [
                       { path: 'listado', component:ListadoDnSubastaComponent},
                       { path: 'xsubastar', component:ListadoDocumentosXSubastarComponent},
                       { path: 'nuevo', component:NuevoDnSubastaComponent},
                       { path: '**', redirectTo: 'listado', pathMatch: 'full', },
            ]},
            { path: 'empresa', component:EmpresaRiesgoComponent,
                    canActivateChild:[AuthGuard],
                    children: [
                    { path: 'listado', component: ListadoEmpresaRiesgoComponent },
                    { path: 'nuevo', component: NuevaEmpresaRiesgoComponent },
                    { path: 'excepciones', component: ListadoExcepcionesComponent },
                    { path: 'listaNegra', component: ListaNegraComponent },
                    { path: '**', redirectTo: 'listado', pathMatch: 'full', },
            ]},
            { path: 'prospecto-respuesta', component: ProspectoRespuestaComponent,
                    canActivateChild:[AuthGuard],
                    children: [
                    { path: 'listado', component: ListadoProspectosComponent },    
                    { path: 'nuevo', component: NuevaRespuestaProspectoComponent },    
                    { path: '**', redirectTo: 'listado', pathMatch: 'full' }
                ]},
            { path: 'cartera', component: CarteraRiesgoComponent, // no se usa
                canActivateChild:[AuthGuard],    
                children: [
                    { path: '**', redirectTo: 'listado', pathMatch: 'full' }// no se usa
            ]},
            { path: 'Configuracion-riesgos', component: ConfiguracionRiesgoComponent,
                canActivateChild:[AuthGuard],  
                children: [
                    { path: 'listadoEmpresa', component: SectorEmpresaComponent},
                    { path: 'listado', component: ListadoSectorComponent},
                    { path: 'nuevoSector', component: NuevoSectorComponent},
                    { path: '**', redirectTo: 'listado', pathMatch: 'full' }
            ]},
        ]
    },
    
    {
        path: 'fondo',
        component:FondoComponent,
        children: [
            { path: 'concentracion', component: ConcentracionFondoComponent, 
                children: [
                    { path: 'dashboardFondo', component: DashboardConcentracionFondoComponent},
                    { path: 'fondos', component: FondosComponent,
                    canActivateChild:[AuthGuard],
                        children : [
                            { path: 'nuevo', component: NuevoFondoComponent },
                            { path: 'listado', component: ListadoFondosComponent},
                            { path: 'retiro/:id', component: RetiroInversionComponent},
                            { path: 'deposito/:id', component: DepositoInversionComponent},
                            { path: '**', redirectTo: 'listado', pathMatch: 'full' }
                        ]    
                    },
                    { path: 'garantias', component: GarantiasComponent,
                    canActivateChild:[AuthGuard],
                        children : [
                            { path: 'nuevo', component: NuevaGarantiaComponent},
                            { path: 'listado', component: ListadoGarantiasComponent },
                            { path: '**', redirectTo: 'listado', pathMatch: 'full' }
                        ]    
                    },
                    { path: '**', redirectTo: 'dashboardFondo', pathMatch: 'full' }
            ]},
            { path: 'financiamiento', component: FinanciamientoComponent, 
                children: [
                    { path: 'listado', component: ListadoFinanciamientoComponent},
                    { path: 'traspaso/:action/:id', component: TraspasoInversionComponent},
                   
                    { path: '**', redirectTo: 'listado', pathMatch: 'full' }
            ]},
        ]
    },
    { path: 'operaciones', 
    component: OperacionesComponent,
    children:  [
            { path: 'simulador', component: SimuladorComponent,
            canActivateChild:[AuthGuard],
                 children: [
                     { path: 'documentos', component: ListadoDocumentosAsociadosComponent  },
                    { path: 'listado', component: ListadoSimuladorComponent  },
                    { path: 'nuevo', component: SimuladorNuevoComponent  },
                    { path: '**', redirectTo: 'listado', pathMatch: 'full', },
                ]},
            { path: 'linea-adquirente',  component: LineaAdquirenteComponent,
              canActivateChild:[AuthGuard],
              children: [
                  { path: 'listado', component: ListaLineasComponent  },
                  //{ path: 'nuevo', component: NuevaLineaComponent  },
                  //{ path: 'detalle', component: DetalleLineaComponent  },
                  { path: '**', redirectTo: 'listado', pathMatch: 'full' }
              ]}, 
            { path: 'propuesta-operacion', component: EvaluacionOperacionComponent,
            canActivateChild:[AuthGuard],
                children: [
                    { path: 'documentos', component: ListaDocumentosComponent},
                    { path: 'listado', component: ListaEvaluacionOperacionComponent },
                    { path: 'detalle', component: DetalleEvaluacionOperacionComponent},
                    { path: 'nuevo', component: NuevoEvaluacionOperacionComponent},
                    { path: '**', redirectTo: 'listado', pathMatch: 'full' }
                ]
            },
                { path: 'proformas', component: ProformasComponent,
                canActivateChild:[AuthGuard],
                 children: [
                     { path: 'documentos', component: ListadoDocumentosAsociadosComponent  },
                    { path: 'listado', component: ListadoProformasComponent  },
                    { path: 'nuevo', component: NuevoProformaComponent  },
                    { path: '**', redirectTo: 'listado', pathMatch: 'full', },
                ]},   
                { path: 'operacion',  component: OperacionComponent,
                canActivateChild:[AuthGuard],
                children: [
                    { path: 'listado', component: ListadoOperacionComponent  },
                    { path: 'listadodetalle',component :OperacionDetalleComponent  },
                    { path: 'nuevo', component: NuevaOperacionComponent  }, 
                    { path: '**', redirectTo: 'listado', pathMatch: 'full', },                 
                ]},   
                { path: 'confirming',  component: ConfirmingComponent,
                canActivateChild:[AuthGuard],
                children: [
                    { path: 'listado', component: ListadoConfirmingComponent  },
                    { path: 'listadodetalle',component :ConfirmingDetalleComponent  },
                    { path: 'nuevo', component: NuevaConfirmingComponent  }, 
                    { path: '**', redirectTo: 'listado', pathMatch: 'full', },                 
                ]}, 
              { path: 'solicitudDesembolso',  component: SolicitudDesembolsoComponent,
              canActivateChild:[AuthGuard],
              children: [
                  { path: 'listado', component: ListadoSolicitudDesComponent  },
                  { path: 'detalle', component: SolicitudDesDetalleComponent  },
                  { path: 'nuevo', component: NuevoSolicitudDesComponent  },
                  { path: 'notificar', component: NotificarSolicitudDesembolsoComponent  },
                  { path: '**', redirectTo: 'listado', pathMatch: 'full', },
              ]},        
              { path: 'prospectos',  component: ProspectosComponent,
              canActivateChild:[AuthGuard],
              children: [
                  { path: 'listado', component: ListadoOperacionesProspectosComponent  },
                  { path: '**', redirectTo: 'listado', pathMatch: 'full', },
              ]},                 
          ]            
  },

  {
      path:'tesoreria',
      component: TesoreriaComponent,
      children: [
          { path: 'desembolso', component:DesembolsoComponent,
          canActivateChild:[AuthGuard],
          children: [
            { path: 'listado', component: ListadoDesembolsoComponent },
            { path: 'detalle', component: ConfirmarDesembolsoComponent },
            { path: 'nuevo', component: NuevoDesembolsoComponent },
            { path: 'nuevoLiquidacion', component: NuevoPlanillaLiquidacionComponent },
            { path: 'verificacion-planilla-desembolso', component: VerificacionPlanillaDesembolsoComponent },
            { path: '**', redirectTo: 'listado', pathMatch: 'full', },
          ]},
      ]
  },

  {
    path: 'cobranzas',
    component: CobranzaComponent,
    children: [
        { path: 'cobranza', component: CobranzasComponent,
        canActivateChild:[AuthGuard],
         children: [
            { path: 'listado', component: ListadoCobranzaComponent },
            { path: 'nuevo', component: NuevoCobranzaComponent },
            { path: '**', redirectTo: 'listado', pathMatch: 'full', },
        ]},

        { path: 'pagos',  component: PagosComponent,
        canActivateChild:[AuthGuard],
        children: [
            { path: 'listado', component: ListadoPagoComponent },
            { path: 'adquirente', component: AdquirentePagoComponent },
            { path: 'detalle', component: DetallePagoComponent },
            { path: 'cuotas', component: AdquirenteCuotaComponent },
            { path: '**', redirectTo: 'listado', pathMatch: 'full', },
        ]},
        { path: 'deudas', component: DeudasComponent,
        canActivateChild:[AuthGuard],
        children: [
            { path: 'listado', component:ListadoDeudasComponent},
            { path: '**', redirectTo: 'listado', pathMatch: 'full', },
        ]} ,
        { path: 'negociaciones',  component: NegociacionesComponent,
        canActivateChild:[AuthGuard],
        children: [
            { path: 'listadoJudicial', component: ListadoCobranzaJudicialComponent },
            { path: 'listadoReprogramacion', component: ListadoReprogramacionComponent },
            { path: '**', redirectTo: 'listadoJudicial', pathMatch: 'full', },
        ]},                        
    ]
  },  

  {
    path: 'reportes',
        component: ReportesComponent,
        children: [
            { path: 'comercial', component: RepComercialComponent,
            canActivateChild:[AuthGuard],
                children: [
                    { path: 'listado', component: ListadoRepComercialComponent},
                    { path: 'factura-negociada', component: ReporteFacturaNegociadaComponent},
                    { path: 'calculo-comision', component: ReporteCalculoComisionComponent},
                    { path: 'clientes-obligados', component: ReporteClienteObligadoComponent},
                    { path: 'numero-operaciones', component: ReporteNumeroOperacionesComponent},
                   
                    { path: '**', redirectTo: 'factura-negociada', pathMatch: 'full' }
                ]
            },
            { path: 'contabilidad', component: RepContabilidadComponent,
            canActivateChild:[AuthGuard],
                children: [
                    { path: 'facturas-generadas', component: ListarFacturasGeneradasComponent},
                    { path: 'operaciones-tiempo', component: OperacionesDetalladasTiempoComponent},
                    { path: 'operaciones-general', component: OperacionesGeneralComponent},
                    { path: 'facturas-negociadas-fondo', component: FacturasNegociadasFondoComponent},
                    { path: 'facturas-neg-sector-fondo', component: FacturasNegSectorFondoComponent},
                    { path: 'facturas-neg-proceso-sector', component: FacturasNegProcesoSectorComponent},
                    { path: 'negociable/listado', component: ListaComprobanteElectronicoComponent},
                    { path: 'comprobantesIF/listado', component: ListaComprobanteIfComponent},
                    { path: 'conciliaciones/listado', component: ListadoRepConciliacionesComponent},                             
                    { path: '**', redirectTo: 'operaciones-general', pathMatch: 'full' }
                ]
            },
            { path: 'finanzas', component: RepFinanzasComponent, 
            canActivateChild:[AuthGuard],
                children: [
                    { path: 'listado', component: ListadoOperacionesEstadoComponent},
                    { path: 'stock-cartera', component: StockCarteraComponent},
                    { path: 'desembolso-operaciones', component: DesembolsosOperacionesComponent},
                    { path: 'cancelacion-operaciones', component: CancelacionesOperacionesComponent},
                    { path: 'devolucion-retenciones', component: DevolucionRetencionesComponent},
                    { path: 'stock-retenciones', component: StockRetencionesComponent},
                    { path: 'pago-adquirentes/listado', component: ListadoPagoAdqComponent},
                    { path : 'fondo-inversion', component: FondoInversionComponent},
                    { path : 'accial', component: AccialComponent},
                    { path : 'conciliacion', component: RepConciliacionComponent},
                    { path : 'Mensual', component: RepMensualComponent},
                    { path : 'Concar', component: RepConcarComponent},
                    { path: '**', redirectTo: 'listado', pathMatch: 'full' },
                ]
            },
            { path:'cobranzas', component: RepCobranzasComponent,
            canActivateChild:[AuthGuard],
                children: [
                    { path: 'facturas-vencidas', component:ListadoFacturasVencidasComponent},
                    { path: 'facturas-merito', component:ListadoFacturasMeritoComponent},
                    { path: 'facturas-judicial', component:ListadoFacturasJudicialComponent},
                    { path: 'listado', component:ListadoFacturasVencidasComponent},
                    { path: 'listado-merito', component:ListadoFacturasMeritoComponent},
                    { path: 'listado-judicial', component:ListadoFacturasJudicialComponent},
                    { path: '**', redirectTo: 'facturas-vencidas', pathMatch: 'full' }
                ]
            },
            { path:'marketing', component: RepMarketingComponent,
            canActivateChild:[AuthGuard],
                children: [
                    { path: 'listado', component: ListadoRepMarketingComponent},
                    { path: 'listado-cliente', component: ListadoEmpresaClienteComponent},
                    { path: 'listado-obligado', component: ListadoEmpresaObligadoComponent},
                    { path: 'listado-ultima', component: ListadoEmpresaUltimaComponent},
                    { path: '**', redirectTo: 'listado-cliente', pathMatch: 'full' }
                ]
            }                                
        ]
    },

    {
    path: 'contabilidad',
    component: ContabilidadComponent,
    canActivateChild:[AuthGuard],
        children: [
            { path: 'tipoCambio/listado', component: ListaTipoCambioComponent},
            { path: 'tipoCambio/nuevoTipoCambio', component: NuevoTipoCambioComponent},
            { path: '**', redirectTo: 'listado', pathMatch: 'full' }
        ]
    },
    {
    path: 'cavali',
    component: CavaliComponent,
    children: [
        { path: 'listado', component: ListadoCavaliComponent,canActivate: [AuthGuard] },
        { path: 'proceso', component: ProcesoCavaliComponent,canActivate: [AuthGuard] },
        { path: 'registrar', component: RegistrarCavaliComponent,canActivate: [AuthGuard] },
    ]
  },  
  {
    path:'liquidacion',
    component: LiquidacionComponent,
    children: [
        { path: 'liquidaciones', component:LiquidacionesComponent,
        canActivateChild:[AuthGuard],
        children: [
          { path: 'listado', component: ListadoLiquidacionesComponent },
          { path: 'planilla', component: PlanillaLiquidacionesComponent },
          { path: 'nuevo', component: NuevaLiquidacionComponent },
          { path: '**', redirectTo: 'listado', pathMatch: 'full' },
        ]},
        { path: 'liquidaciones-resumen', component:ResumenLiquidacionComponent,
        canActivateChild:[AuthGuard],
        children: [
          { path: 'listado', component: ListadoResumenComponent },
          { path: 'nuevo', component: NuevoResumenComponent },
          { path: '**', redirectTo: 'listado', pathMatch: 'full', },
        ]},
    ]
},
{
    path:'inversion',
    component: InversionComponent,
    children: [
        { path: 'inversionistas', component:InversionistasComponent,
        canActivateChild:[AuthGuard],
        children: [
          { path: 'listado', component: ListadoInversionistasComponent },
          { path: 'nuevo', component: NuevoInversionComponent },
          { path: '**', redirectTo: 'listado', pathMatch: 'full', },
        ]},
    ]
},
{
    path:'libroReclamaciones',
    component: LibroReclamacionesComponent,
    children: [
        { path: 'quejasReclamos', component:QuejasReclamosComponent,
        canActivateChild:[AuthGuard],
        children: [
          { path: 'listado', component: ListadoQuejasReclamosComponent},
          { path: 'nuevo', component: NuevoQuejasReclamosComponent },
          { path: '**', redirectTo: 'listado', pathMatch: 'full', },
        ]},
    ]
},
{
    path: 'facturacion',
    component: FacturacionComponent,
    children: [
        { path: 'factura', component: FacturasComponent,
        canActivateChild:[AuthGuard],
         children: [
            { path: 'listado', component: ListadoCpeComponent },
            { path: 'nuevo', component: NuevoCpeComponent },
            { path: 'facturaCpe', component: CpeFacturaComponent },
            { path: '**', redirectTo: 'listado', pathMatch: 'full', },
        ]},

        { path: 'notaCredito',  component: NotaCreditoComponent,
        canActivateChild:[AuthGuard],
        children: [
            { path: 'listado', component: ListadoCpeComponent },
            { path: 'nuevo', component: CpeNotaCreditoComponent },
            { path: 'notaCreditoCpe', component: CpeNotaCreditoComponent },
            { path: '**', redirectTo: 'listado', pathMatch: 'full', },
        ]}, 
        { path: 'notaDebito',  component: NotaDebitoComponent,
        canActivateChild:[AuthGuard],
        children: [
            { path: 'listado', component: ListadoCpeComponent },
            { path: 'nuevo', component: CpeNotaDebitoComponent },
            { path: 'notaDebitoCpe', component: CpeNotaDebitoComponent },
            { path: '**', redirectTo: 'listado', pathMatch: 'full', },
        ]},                        
    ]
},

{
    path: 'empresaSeg',
    component: EmpresaSegComponent,
    canActivateChild:[AuthGuard],
    children: [
        { path: 'listado', component: ListadoComponent },
        { path: 'nuevaEmpresa', component: NuevoEmpresaComponent },
        { path: 'parametro', component: ParametroComponent },
        { path: '**', redirectTo: 'listado', pathMatch: 'full', },
    ]
},
{
    path: 'sistema',
    component: SistemaComponent,
    canActivateChild:[AuthGuard],
    children: [
        { path: 'listado', component: ListadoSistemaComponent },
        { path: 'nuevoSistema', component: NuevoSistemaComponent },
        { path: '**', redirectTo: 'listado', pathMatch: 'full', },
    ]
},
{
    path: 'rol',
    component: RolComponent,
    canActivateChild:[AuthGuard],
    children: [
        { path: 'listado', component: ListadoRolComponent },
        { path: 'nuevoRol', component: NuevoRolComponent },
        { path: '**', redirectTo: 'listado', pathMatch: 'full', },
    ]
},
{ path: 'acceso', 
  component: AccesoComponent,
  canActivateChild:[AuthGuard],
    children: [
        { path: 'listado', component: ListadoAccesoComponent },
        { path: 'nuevoAcceso', component: NuevoAccesoComponent },        
        { path: '**', redirectTo: 'listado', pathMatch: 'full', },
    ]
},
{
    path: 'permiso',
    component: PermisoComponent,
    canActivateChild:[AuthGuard],
    children: [
        { path: 'listado', component: ListadoPermisoComponent },
        { path: 'nuevoPermiso', component: NuevoPermisoComponent },
        { path: '**', redirectTo: 'listado', pathMatch: 'full', },
    ]
},
{
    path: 'componentes',
    component: ComponentesComponent,
    canActivateChild:[AuthGuard],
    children: [
        { path: 'listado', component: ListadoComponenteComponent },
        { path: 'nuevoComponente', component: NuevoComponenteComponent },
        { path: 'permisoComponente', component: PermisoComponenteComponent },
        { path: '**', redirectTo: 'listado', pathMatch: 'full', },
    ]
},
{
    path: 'guias',
    component: GuiasComponent,
    canActivateChild:[AuthGuard],
    children: [
        { path: 'listado', component: ListadoGuiaComponent },
        { path: '**', redirectTo: 'listado', pathMatch: 'full', },
    ]
},
{ path: 'usuarios',     component: UsuarioComponent,
canActivateChild:[AuthGuard],
    children: [
        { path: 'listado', component: ListaUsuarioComponent },
        { path: 'nuevoUsuario', component: NuevoUsuarioComponent },
        { path: 'editarUsuario', component: NuevoUsuarioComponent },
        { path: '**', redirectTo: 'listado', pathMatch: 'full', },
    ]
},

{
    path: 'contratoMarco',
    component: ContratoMarcoComponent,
    canActivateChild:[AuthGuard],
    children: [
        { path: 'listadoCM', component: ListadoContratoMarcoComponent},
        { path: 'pagare', component: PagareComponent },
    ]
  },

  { path: 'upgrade', component: UpgradeComponent },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full', },
];


